import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Icon } from '@platform-ui/design-system';
import { GenericWCWrapper } from '../utils';
export var DSIcon = /*#__PURE__*/function (_GenericWCWrapper) {
  _inherits(DSIcon, _GenericWCWrapper);

  var _super = _createSuper(DSIcon);

  function DSIcon() {
    _classCallCheck(this, DSIcon);

    return _super.call(this, Icon);
  }

  return DSIcon;
}(GenericWCWrapper);

_defineProperty(DSIcon, "_props", ['key'].concat(_toConsumableArray(Object.keys(Icon['__docgenInfo'].props))));
//# sourceMappingURL=Icon.js.map